<template>
	<section
		class="flex flex-col gap-6 px-6 py-4 mt-6 text-[#294451] bg-[#E6EFF4] rounded-lg shadow-sm"
	>
		<div class="flex items-start gap-4">
			<div
				class="flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-full bg-[#CEE1E9]"
			>
				<IconInfoCircle size="24" />
			</div>
			<div class="min-w-0">
				<h4 class="mb-0 text-lg font-medium">
					{{ $t(copy.heading) }}
				</h4>
				<p class="mb-0 text-base">
					{{ $t(copy.subheading) }}
				</p>
			</div>
		</div>

		<div class="sm:pl-16">
			<h5 class="mb-2 text-base font-medium">
				{{ $t(copy.firstColumnHeading) }}
			</h5>
			<ul class="flex flex-col gap-[6px] mb-0 text-sm">
				<li
					v-for="bulletPoint in copy.bulletPoints"
					:key="bulletPoint"
					class="flex items-start gap-2"
				>
					<IconCheckCircle size="16" class="mt-0.5 shrink-0" />
					<span>{{ $t(bulletPoint) }}</span>
				</li>
			</ul>
		</div>

		<div
			class="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:pl-16"
		>
			<nuxt-link v-if="canRetake && retakeQuizLink" :to="retakeQuizLink">
				<Button
					type="secondary"
					:icon-component="IconRepeat"
					icon-size="16"
					class="border-[#DADCDD]"
				>
					{{ $t('personality_results.refine_search.repeat_test') }}
				</Button>
			</nuxt-link>

			<nuxt-link v-if="displayEditButton" :to="editJobOfferLink">
				<Button type="secondary">
					{{
						$t(
							'personality_results.refine_search.modify_requirements'
						)
					}}
				</Button>
			</nuxt-link>
		</div>
	</section>
</template>

<script>
import { IconCheckCircle, IconInfoCircle, IconRepeat } from '~/components/Icons'
import Button from '~/components/ui/common/Button'

export default {
	name: 'RefineSearchHiringManagerCard',
	components: {
		Button,
		IconCheckCircle,
		IconInfoCircle
	},
	props: {
		copy: {
			type: Object,
			required: true
		},
		canRetake: {
			type: Boolean,
			default: false
		},
		retakeQuizLink: {
			type: Object,
			default: null
		},
		displayEditButton: {
			type: Boolean,
			default: false
		},
		editJobOfferLink: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			IconRepeat
		}
	}
}
</script>
